import {
  useGlobalCurrency,
  useGlobalPeriod,
  useSnapshot,
  useReportBespoke,
  useStructureGrouping,
} from "@iliotech/data-wire";
import { useParams } from "react-router-dom";
import { useProfitHistory } from "@iliotech/data-wire";
import { PNLLineChart } from "src/components/__pageComponents/PnlPage/components/PNLLineChart";
import { ValueLegend } from "src/main";
import { useSnapshotLegendItems } from "../../__shared/useSnapshotLegendItems";
import * as React from "react";
import { ReportWidgetProps } from "../../ReportWidgetProps";

export const PnLByAssetClassWidget = ({
  height,
  width,
  isHalfHeight,
  structureContext,
  periodContext,
}: ReportWidgetProps) => {
  const { portfolioId } = useParams();
  const { grouping, selectedGroup } =
    structureContext || useStructureGrouping();
  const profitHistory = useProfitHistory(portfolioId!, periodContext);
  const { currencyFormatter } = useGlobalCurrency();
  const store = useReportBespoke();
  const generating = store.generating;
  const snapshots = useSnapshot(portfolioId!);
  const { periodString } = periodContext || useGlobalPeriod();
  const { getLegendItems } = useSnapshotLegendItems({
    grouping: grouping!,
    currencyFormatter,
    snapshots: snapshots?.data?.data ?? [],
    t: () => "",
  });

  const allPositionLegendItems = getLegendItems(false);

  const memoizedPNLLineChart = React.useMemo(
    () =>
      !profitHistory?.isLoading && (
        <PNLLineChart
          generating={generating}
          currencyFormatter={currencyFormatter}
          profitHistory={profitHistory}
          grouping={grouping!}
          selectedGroup={selectedGroup}
          height={height}
          width={width}
          showNavigator={false}
        />
      ),
    [
      profitHistory?.isLoading,
      generating,
      currencyFormatter,
      profitHistory,
      grouping,
      selectedGroup,
      height,
      width,
    ]
  );

  return (
    <div>
      <h4 className={"element-title"}>
        PnL by {grouping?.label || "Asset Class"}
      </h4>
      <p className={"period-string"}>{periodString}</p>
      {memoizedPNLLineChart}
      <ValueLegend small={isHalfHeight} items={allPositionLegendItems} />
    </div>
  );
};
